import { css } from '@emotion/css';
import commonApi from 'apis/commonApi';
import Modal from 'components/modal/Modal';
import { rotateAnimation } from 'constants/global.style';
import { colors } from 'constants/theme';
import { PromoDetailResponse } from 'models/promotionModel';
import { MsgDetail } from 'pages/homepage/msg-detail/msg-detail';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';

function NotiftyAll() {
    const [msgList, setMsgList] = useState<PromoDetailResponse[]>([]);
    const [, setIsRefreshing] = useState(false);
    const [showPopupDetail, setShowPopupDetail] = useState(false);
    const [msgDetail, setMsgDetail] = useState<{ id: number; title: string; content: string }>();

    useEffect(() => {
        initMsgSystemBean();
    }, []);

    const initMsgSystemBean = async (isRefresh?: boolean) => {
        if (isRefresh) {
            setIsRefreshing(true);
        }
        try {
            const { data } = await commonApi.getMsgSystemBean({});
            if (!data.msg) {
                const msgData: PromoDetailResponse[] = data.msglist.filter((item: PromoDetailResponse) => item.status === 1);
                const popupList: PromoDetailResponse[] = data.msglist.filter((item: PromoDetailResponse) => item.status === 2);
                if (popupList.length > 0) {
                    insertPopupIntoMsgList(msgData, popupList[0]);
                } else {
                    setMsgList(msgData);
                }
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsRefreshing(false);
        }
    };

    const insertPopupIntoMsgList = async (msgData: PromoDetailResponse[], popupItem: PromoDetailResponse) => {
        try {
            const { data } = await commonApi.sysMsgBeanInfo({ id: popupItem.id });
            if (!data.msg && !data.sysmsg.content.includes('popup')) {
                msgData = [...msgData, popupItem];
            }
            setMsgList(msgData);
        } catch (error) {
            console.log(error);
            setMsgList(msgData);
        }
    };

    const getMsgDetail = async (msgId: number) => {
        setShowPopupDetail(true);
        try {
            const { data } = await commonApi.sysMsgBeanInfo({ id: msgId });
            if (!data.msg) {
                setMsgDetail(data.sysmsg);
            } else {
                toast.error(data.msg);
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <>
            <div className={styles.wrap}>
                <div className="">
                    <div className={styles.messageList}>
                        {msgList.map((item) => (
                            <div className={styles.messageItem} key={item.id} onClick={() => getMsgDetail(item.id)}>
                                <p>{item.title}</p>
                                <span>{item.begins}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <Modal isShow={showPopupDetail} onClose={() => setShowPopupDetail(false)} width="62vw" closeClickBackdrop>
                <MsgDetail data={{ title: msgDetail?.title || '', content: msgDetail?.content || '', photourl: '' }} onClose={() => setShowPopupDetail(false)} />
            </Modal>
        </>
    );
}

const styles = {
    wrap: css`
        color: black;
        padding: 20px;
        background-color: white;
        border-radius: 8px;
    `,
    btnRefresh: css`
        display: flex;
        align-items: center;
        margin-left: auto;
        width: fit-content !important;
        padding: 6px 12px;
        border-radius: 8px;
        span {
            margin-left: 4px;
            font-size: 14px;
        }
        img {
            width: 20px;
        }
        &.rotate {
            img {
                animation: ${rotateAnimation} 0.8s linear infinite;
            }
        }
    `,
    messageList: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
        margin-top: 20px;
    `,
    messageItem: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        margin-bottom: 15px;
        font-size: 15px;
        border-bottom: 1px dotted #d4d4d4;
        padding-bottom: 15px;

        &:hover {
            p {
                color: ${colors.orange};
            }
            svg {
                transform: translateX(4px);
            }
        }
        p {
            white-space: nowrap;
            text-overflow: ellipsis;
            flex: 1;
            overflow: hidden;
            margin-right: 24px;
            font-size: 16px;
        }
        span {
            color: #adb0b6;
            font-size: 14px;
        }
        svg {
            transition: 0.25s;
        }
    `,
    popup: css`
        display: flex;
        flex-direction: column;
        min-height: 400px;
    `,
    popupContent: css`
        flex: 1;
    `,
};

export default NotiftyAll;
